export const SALUTATIONS: Array<string> = [
  "Dr.",
  "Mr.",
  "Ms.",
  "Mrs.",
  "Prof.",
  "No honorific required",
];

//@TODO C4Sheep Removed NHR here.
// 'No honorific required'

export const COUNTRIES: Array<string> = [
  "Hong Kong SAR",
  "China",
  "Macau SAR",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  // 'China',
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of the",
  "Congo, Republic of the",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Islas Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern and Antarctic Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (Vatican City)",
  "Honduras",
  // 'Hong Kong SAR',
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  // 'Macau SAR',
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Islands",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena, Ascension, and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "State of Palestine",
  "Sudan",
  "Suriname",
  "Svalbard",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Åland Islands",
];

export const REGIONS: { [key: string]: Array<string> } = {
  "Hong Kong SAR": ["Hong Kong Island", "Kowloon", "New Territories"],
};

export const DISTRICTS: { [key: string]: Array<string> } = {
  "Hong Kong Island": [
    "Central and Western",
    "Eastern",
    "Southern",
    "Wan Chai",
  ],
  Kowloon: [
    "Kowloon City",
    "Kwun Tong",
    "Sham Shui Po",
    "Wong Tai Sin",
    "Yau Tsim Mong",
  ],
  "New Territories": [
    "Islands",
    "Kwai Tsing",
    "North",
    "Sai Kung",
    "Sha Tin",
    "Tai Po",
    "Tsuen Wan",
    "Tuen Mun",
    "Yuen Long",
  ],
};

export const AREAS: { [key: string]: Array<string> } = {
  "Central and Western": [
    "Kennedy Town",
    "Shek Tong Tsui",
    "Sai Ying Pun",
    "Sheung Wan",
    "Central",
    "Admiralty",
    "Mid-levels",
    "Peak",
  ],
  Eastern: [
    "Tin Hau",
    "Braemar Hill",
    "North Point",
    "Quarry Bay",
    "Sai Wan Ho",
    "Shau Kei Wan",
    "Chai Wan",
    "Siu Sai Wan",
  ],
  Southern: [
    "Pok Fu Lam",
    "Aberdeen",
    "Ap Lei Chau",
    "Wong Chuk Hang",
    "Shouson Hill",
    "Repulse Bay",
    "Chung Hom Kok",
    "Stanley",
    "Tai Tam",
    "Shek O",
  ],
  "Wan Chai": [
    "Wan Chai",
    "Causeway Bay",
    "Happy Valley",
    "Tai Hang",
    "So Kon Po",
    `Jardine's Lookout`,
  ],
  "Kowloon City": [
    "Hung Hom",
    "To Kwa Wan",
    "Ma Tau Kok",
    "Ma Tau Wai",
    "Kai Tak",
    "Kowloon City",
    "Ho Man Tin",
    "Kowloon Tong",
    "Beacon Hill",
  ],
  "Kwun Tong": [
    "Ping Shek",
    "Kowloon Bay",
    "Ngau Tau Kok",
    "Jordan Valley",
    "Kwun Tong",
    "Sau Mau Ping",
    "Lam Tin",
    "Yau Tong",
    "Lei Yue Mun",
  ],
  "Sham Shui Po": [
    "Mei Foo",
    "Lai Chi Kok",
    "Cheung Sha Wan",
    "Sham Shui Po",
    "Shek Kip Mei",
    "Yau Yat Tsuen",
    "Tai Wo Ping",
    "Stonecutters Island",
  ],
  "Wong Tai Sin": [
    "San Po Kong",
    "Wong Tai Sin",
    "Tung Tau",
    "Wang Tau Hom",
    "Lok Fu",
    "Diamond Hill",
    "Tsz Wan Shan",
    "Ngau Chi Wan",
  ],
  "Yau Tsim Mong": [
    "Tsim Sha Tsui",
    "Yau Ma Tei",
    "West Kowloon Reclamation",
    `King's Park`,
    "Mong Kok",
    "Tai Kok Tsui",
  ],
  Islands: [
    "Cheung Chau",
    "Peng Chau",
    "Lantau Island (incl. Tung Chung)",
    "Lamma Island",
  ],
  "Kwai Tsing": ["Kwai Chung", "Tsing Yi"],
  North: [
    "Fanling",
    "Luen Wo Hui",
    "Sheung Shui",
    "Shek Wu Hui",
    "Sha Tau Kok",
    "Luk Keng",
    "Wu Kau Tang",
  ],
  "Sai Kung": [
    "Clear Water Bay",
    "Sai Kung",
    "Tai Mong Tsai",
    "Tseung Kwan O",
    "Hang Hau",
    "Tiu Keng Leng",
    "Ma Yau Tong",
  ],
  "Sha Tin": [
    "Tai Wai",
    "Sha Tin",
    "Fo Tan",
    "Ma Liu Shui",
    "Wu Kai Sha",
    "Ma On Shan",
  ],
  "Tai Po": [
    "Tai Po Market",
    "Tai Po",
    "Tai Po Kau",
    "Tai Mei Tuk",
    "Shuen Wan",
    "Cheung Muk Tau",
    "Kei Ling Ha",
  ],
  "Tsuen Wan": [
    "Tsuen Wan",
    "Lei Muk Shue",
    "Ting Kau",
    "Sham Tseng",
    "Tsing Lung Tau",
    "Ma Wan",
    "Sunny Bay",
  ],
  "Tuen Mun": ["Tai Lam Chung", "So Kwun Wat", "Tuen Mun", "Lam Tei"],
  "Yuen Long": [
    "Hung Shui Kiu",
    "Ha Tsuen",
    "Lau Fau Shan",
    "Tin Shui Wai",
    "Yuen Long",
    "San Tin",
    "Lok Ma Chau",
    "Kam Tin",
    "Shek Kong",
    "Pat Heung",
  ],
};
